import { render } from "./Intel.vue?vue&type=template&id=4ebb797c"
import script from "./Intel.vue?vue&type=script&lang=js"
export * from "./Intel.vue?vue&type=script&lang=js"

import "./Intel.vue?vue&type=style&index=0&id=4ebb797c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__